import {
    BrowserRouter,
    Navigate,
    Route,
    Routes,
} from "react-router-dom";
import {
    AuthProvider,
    ProtectedRoute,
} from "./components/auth/index.ts";
import {
    AppErrorBoundary,
} from "./components/common/AppErrorBoundary.tsx";
import ManagePage from "./pages/ManagePage.tsx";
import PermalinkPage from "./pages/PermalinkPage.tsx";
import ProfilePage from "./pages/ProfilePage.tsx";
import ViewerPage from "./pages/ViewerPage.tsx";

const App = () => {
    return (
        <BrowserRouter>
            <AppErrorBoundary>
                <AuthProvider>
                    <Routes>
                        <Route path="/p/:itemId" element={<PermalinkPage />} />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <ViewerPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/manage"
                            element={
                                <ProtectedRoute requiredPermission="can_manage">
                                    <ManagePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/profile/:userId"
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </AuthProvider>
            </AppErrorBoundary>
        </BrowserRouter>
    );
};

export default App;
